// Copyright (c) 2016 Deere & Company
import Modal, { getDefaultState as getModalDefaultState } from '../state/modal';
import actions from '../actions-list';

const updateModalVisibility = (state, action) => {

    const toggleVisibility = !action.isVisible;

    return Modal.update(state, {
        isVisible: {
            $set: toggleVisibility,
        },
    });

};

export default (state = getModalDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_MODAL_VISIBILITY]: updateModalVisibility,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
